import React from 'react';

export const theme = {theme: localStorage.getItem('theme')==null ? 'light' : localStorage.getItem('theme')};

export const ThemeContext = React.createContext(null);